<div class="row pt-5">

  <div class="col-md-6 mx-auto">

    <span class="anchor" id="formLogin"></span>

    <div class="card login-card-body-border-radius">

      <div class="card-header flex-row-space-between">
        <h3 class="mb-0">Einloggen</h3>
        <core-button-slight
          *ngIf="false"
          id="register"
          (click)="onRegister()"
          [text]="'Neuen Account erstellen!'"
          [type]="InputButtonIconType.PRIMARY">
        </core-button-slight>
      </div>

      <form [formGroup]="form" class="login-card-body">

        <core-input-email
          [showClearButton]="false"
          formControlName="email"
          id="email"
          topLabel="E-Mail">
        </core-input-email>

        <core-input-password
          [enableBrowserSuggestion]="true"
          [showClearButton]="false"
          formControlName="password"
          id="password"
          topLabel="Passwort">
        </core-input-password>

        <core-button
          (click)="onLogin()"
          [icon]="['fas', 'check']"
          [text]="'Login'"
          [width]="'50%'"
          id="submit"
          style="text-align: center;">
        </core-button>

      </form>

      <p-progressBar *ngIf="loading" [style]="{'height': '10px'}" mode="indeterminate"></p-progressBar>

    </div>

  </div>

</div>
